module.exports = __webpack_public_path__ + "coin_ARB.png?e0e14606f4aab18e3f9aa2e115257fd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_ARB.png
// module id = 458
// module chunks = 2